























































import clientModel from "@/api/client.model";
import { Client } from "@/entities/client";
import { spreadsheetTemplates } from "@/helpers/templateImport";
import { isValidCPF, isValidPhoneNumber } from "@/helpers/utils";
import CustomTabs from "@/layouts/components/CustomTabs.vue";
import CustomUserCard from "@/layouts/components/UserCard.vue";
import { BOverlay, BSpinner } from "bootstrap-vue";
import { Component, Vue } from "vue-property-decorator";
import blockedClientModel from "../../api/blocked_client.model";
import { BlockedClient } from "../../entities/blocked_client";
import { requireConfirmation, showErrorAlert, showSuccessAlert } from "../../helpers";
import CustomButton from "../../layouts/components/Button.vue";
import InclusionType from "../InclusionType.vue";
import EntityForm from "../entity/EntityForm.vue";

@Component({
	components: {
		"custom-button": CustomButton,
		"user-card": CustomUserCard,
		"custom-tabs": CustomTabs,
		BOverlay,
		BSpinner,
		InclusionType,
	},
})
export default class BlockedClientsForm extends Vue {
	isEditing = true;
	currentTabIndex = 0;
	modelForm = new BlockedClient({}) as any;
	client = new Client({}) as any;
	loading = false;
	loadingErrorButton = false;
	loadingButton = false;
	isEntityLoading = false;
	mainEntity = {};
	buttonDisabled = false;
	localIsReadOnly = true;
	blockedClientModel = blockedClientModel;
	templateDownload = spreadsheetTemplates.blocked_clients;

	formColumnsMainData: any = [
		{
			key: "cpf",
			required: false,
			validationField: isValidCPF,
			messageError: "CPF inválido",
		},
		{
			key: "phoneNumber",
			required: false,
			validationField: isValidPhoneNumber,
			messageError: "Número de telefone inválido",
		},
	];

	get mainTabs() {
		return [
			{
				name: "Dados Principais",
				component: EntityForm,
				componentName: "EntityForm",
				props: {
					isLoadEntity: false,
					isCustomEntity: true,
					customEntity: this.modelForm,
					onCreateOrUpdateEntity: this.lockEdition,
					model: blockedClientModel,
					formColumns: this.formColumnsMainData,
					withBackButton: false,
					withPostalCode: false,
					cleanFormKeys: {
						deleteKeys: ["id", "createdDate", "updatedDate"],
					},
					onInputChange: this.changeSelect,
				},
			},
		];
	}

	creationTabs = [
		{
			name: "Dados Principais",
			component: EntityForm,
			componentName: "EntityForm",
			props: {
				isLoadEntity: false,
				isCustomEntity: true,
				customEntity: this.mainEntity,
				model: blockedClientModel,
				formColumns: this.formColumnsMainData,
				withBackButton: false,
				withPostalCode: false,
				newErrors: {},
				cleanFormKeys: {
					deleteKeys: ["id", "createdDate", "updatedDate"],
				},
				onInputChange: this.changeSelect,
			},
		},
	];

	creationComponent = {
		component: CustomTabs,
		componentName: "CustomTabs",
		props: {
			tabs: this.creationTabs,
		},
		isCustomEntity: true,
		customEntity: this.mainEntity,
		model: blockedClientModel,
		fieldsRequired: [
			{ key: "cpf", required: false },
			{ key: "phoneNumber", required: false },
		],
	};

	headerButtons = [
		{ icon: "edit-icon.svg", variant: "tertiary", buttonAction: this.unlockEdition, label: undefined },
		{ icon: "trash-icon.svg", variant: "tertiary", buttonAction: this.removeBlockedClient, label: undefined },
	];

	cardHeader = [
		{ key: "name", kind: "userName" },
		{ key: "lastName", kind: "userName" },
	];

	get currentId() {
		return this.$route.params.id;
	}

	async getRelationFields(isLoading = true) {
		this.isEntityLoading = true;
		try {
			let mainData = {} as any;

			if (this.currentId === "novo") {
				mainData = this.creationComponent.props.tabs.find(tab => tab.name === "Dados Principais");
			} else {
				mainData = this.mainTabs.find(tab => tab.name === "Dados Principais");
			}
		} catch (error) {
			console.error(error);
		} finally {
			this.isEntityLoading = false;
		}
	}

	toggleLockEdition(
		shouldBeLocked: boolean,
		startAffectOn?: string,
		ignoreOn?: string,
		componentRef: any = this.$refs.customTabsRef,
	) {
		startAffectOn = this.toKebabCase(startAffectOn);
		ignoreOn = this.toKebabCase(ignoreOn);
		const target = "entity-form";
		const tag = componentRef.$options._componentTag || this.toKebabCase(componentRef.$attrs.component);
		if (startAffectOn && (tag === startAffectOn || startAffectOn === "affect-all")) {
			startAffectOn = "affect-all";
			if (tag === target) {
				componentRef.isReadOnly = shouldBeLocked;
			}
		}
		for (const ref of componentRef.$children) {
			if (ignoreOn && tag === ignoreOn) {
				continue;
			}
			this.toggleLockEdition(shouldBeLocked, startAffectOn, ignoreOn, ref);
		}
	}

	toKebabCase(text?: string) {
		return text
			? text
					.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/gu)!
					.map((str: string) => str.toLowerCase())
					.join("-")
			: "";
	}

	lockEdition() {
		this.toggleLockEdition(true, "CustomTabs");
	}

	unlockEdition() {
		this.localIsReadOnly = false;
		this.toggleLockEdition(false, "CustomTabs");
	}

	async mounted() {
		if (this.currentId && this.currentId !== "novo") {
			await this.loadClientById();
		} else {
			this.toggleLockEdition(false, "CustomTabs");
		}
	}

	async loadClientById() {
		if (this.currentId && this.currentId) {
			this.loading = true;
			const blockedClient: BlockedClient = await blockedClientModel.read(this.$route.params.id);
			const client: Client = await blockedClientModel.getOneBlockedClient(this.$route.params.id);

			this.modelForm = new BlockedClient(blockedClient);
			this.client = new Client(client);
			this.loading = false;
		}
	}

	async save() {
		if (!this.modelForm.cpf && !this.modelForm.phoneNumber) {
			showErrorAlert("Preencha pelo menos o CPF ou o número de telefone.");
			this.loadingButton = false;
			return;
		}

		if (this.currentTabIndex == 0) {
			this.currentTabIndex++;
			return;
		}

		this.loadingButton = true;

		try {
			await blockedClientModel.create(this.modelForm);

			const message = this.modelForm?.id ? "O cliente bloqueado foi atualizado" : "O cliente foi bloqueado";
			showSuccessAlert(message);

			this.$router.back();
		} catch {
			showErrorAlert("Ocorreu um erro ao bloquear cliente!");
		} finally {
			this.loadingButton = false;
		}
	}

	async removeBlockedClient() {
		await requireConfirmation("Confirma a remoção?", "Não será possível reverter esta operação.", "Remover bloqueio");

		this.loadingErrorButton = true;
		try {
			await blockedClientModel.delete(this.modelForm.id, "");
			showSuccessAlert("O bloqueio no cliente foi removido");

			this.$router.back();
		} catch (error: any) {
			showErrorAlert(error?.message ?? "Ocorreu um erro ao remover bloqueio!");
		} finally {
		}
	}

	cleanKeysForUpdate = ["id"];

	cleanFormUpdate() {
		Object.keys(this.modelForm).forEach((key: string) => {
			if (this.cleanKeysForUpdate.includes(key)) {
				delete this.modelForm[key];
			}
		});
	}

	async updateBlockedClient() {
		if (!this.modelForm.cpf && !this.modelForm.phoneNumber) {
			showErrorAlert("Preencha pelo menos o CPF ou o número de telefone.");
			this.isEntityLoading = false;
			return;
		}

		this.isEntityLoading = true;
		this.cleanFormUpdate();

		try {
			await blockedClientModel.update(this.currentId, this.modelForm);
			showSuccessAlert("O cliente bloqueado foi atualizado com sucesso");
			location.reload();
		} catch (error: any) {
			console.error(error);
			showErrorAlert("Ocorreu um erro ao alterar dados do cliente bloqueado!");
		} finally {
			this.isEntityLoading = false;
		}
	}

	changeSelect(value: any, fieldKey: string) {
		this.buttonDisabled = false;
	}

	back() {
		this.$router.back();
	}
}
